import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode.react';
import { Button, TextField, Box, Typography, Container, Select, MenuItem, Radio, RadioGroup, FormControlLabel,FormControl,Grid,FormLabel } from '@mui/material';
import defaultLogo from './bread_financial_logo.png'; // Default logo
import './App.css';
import './QrCodeGenerator.css';
import {useSearchParams} from 'react-router-dom';



function QRCodeGenerator() {
    const [brandData, setBrandData] = useState(null);
    const [fullURL, setFullURL] = useState('');
    const [brandLogo, setBrandLogo] = useState(defaultLogo);
    const [recipient, setRecipient] = useState(''); // <-- NEW STATE FOR RECIPIENT (EMAIL OR PHONE)
    const [email, setEmail] = useState(''); // <-- NEW STATE FOR EMAIL
    const [phone, setPhone] = useState(''); // <-- NEW STATE FOR PHONE
    const [region, setRegion] = useState('');  // Dropdown 1 for Region
    const [productChoice, setProductChoice] = useState('Credit Card 1');  // Product choice state
    const [deliveryMethod, setDeliveryMethod] = useState('QR Code'); // Default to QR Code
    const [regionList, setRegionList] = useState([]);
    const [showRegion, setShowRegion] = useState(true);
    const [showLinkDetail, setShowLinkDetail] = useState(false);
    const resolvedMessage = brandData?.ctaMessage ? brandData.ctaMessage.replace('{cardName}', brandData?.brandcardname || '') : `Scan the QR Code to Apply for a ${brandData?.brandcardname || 'credit card'}`;
    const [searchParams] = useSearchParams();
    const initialStore = searchParams.get('storeNumber') || '';
    const initialAssociateId = searchParams.get('associateId') || '';

    const [storeNumber, setStoreNumber] = useState(initialStore);      // Dropdown 2 for Club
    const [employeeId, setEmployeeId] = useState(initialAssociateId);



    // const baseURL = 'https://acquire1.comenity.net/?clientName=breadcashback&token=123&workflow=tokenlookup&associateId=1234&employeeApplication=true&inStore=true';

    // working prod : const baseURL = 'https://acquire1.comenity.net/unified/prequal-start?cardChoiceCode=2&clientName=cl0ne&embedded=true&epId=5a8a888f-79e7-47cb-8c86-e94ccbf974ac&mockBuyer=success&mockFIE=success&mockPrequal=success&mockPrequalApp=success&mockSOTP=success&mockUCS=success&mockUIO=success&mockUO=success&mockVOTP=success&workflow=unifiedPrequal&associateId=123123&employeeApplication=true&inStore=true'
   const baseURL = 'https://acquire1.comenity.net/?clientName=advantage&workflow=phoneLookup&associateId=123123&employeeApplication=true&inStore=true&cmp=agentqrcode'
    // Load config and determine brand from URL.
    // AEM is tried first using brandPath, then local JSON is used as a fallback.
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const requestedBrand = (urlParams.get('brand') || 'advantage').trim().toLowerCase();
        let canonicalBrand = requestedBrand;
        const showRegionParam = urlParams.get('showregion');
        setShowRegion(showRegionParam !== 'false');
        setShowLinkDetail(urlParams.get("showlinkdetail") === "true");

        const defaultBrandData = {
            brandname: 'advantage',
            applylink: 'https://acquire1.comenity.net/?clientName=advantage&token=123&workflow=tokenlookup&associateId=1234&employeeApplication=true&inStore=true&cmp=agentqrcode',
        };

        const aemGraphqlBaseUrl =
            process.env.REACT_APP_AEM_GRAPHQL_URL ||
            'https://uat-eds-content.comenity.net/graphql/execute.json/aemacquisition';
        const aemMappingUrl = '/aemBrandMapping.json';
        const localConfigUrl = '/EmployeeQRbrandconfig.json';

        // Match either the incoming URL brand or its mapped canonical brand.
        const brandMatches = (value) => {
            const normalizedValue = String(value || '').toLowerCase();
            return normalizedValue === requestedBrand || normalizedValue === canonicalBrand;
        };

        // Local config format matcher (public/EmployeeQRbrandconfig.json).
        const extractLocalBrandPayload = (rawData) => {
            // Local JSON (and legacy GraphQL payload) contains brandList/brandname keys.
            const payload = rawData?.data?.QRPortal || rawData;

            if (Array.isArray(payload?.brandList)) {
                return payload.brandList.find((b) => brandMatches(b.brandname)) || null;
            }

            if (brandMatches(payload?.brandname)) {
                return payload;
            }

            return null;
        };

        // Normalize AEM item fields to the app's existing brand config shape.
        const mapAemItemToBrandPayload = (item) => {
            const mappedBrandName = Array.isArray(item?.clientName) ? item.clientName[0] : item?.clientName;
            const mappedDisclaimerAlignment = Array.isArray(item?.disclaimerAlignment)
                ? item.disclaimerAlignment[0]
                : item?.disclaimerAlignment;

            return {
                brandname: (mappedBrandName || canonicalBrand).toLowerCase(),
                brandlogo: item?.brandLogo?._publishUrl || item?.brandLogo?._dynamicUrl || '',
                brandcardname: item?.clientInformation?.cardName || '',
                brandcolor: item?.brandColor,
                regionLabel: item?.regionLabel,
                branchNumberLabel: item?.branchNumberLabel,
                empidLabel: item?.employeeIdLabel,
                ctaMessage: item?.callToActionMessage?.plaintext,
                disclaimer: item?.disclaimer?.plaintext,
                configbaseurl: item?.configurationBaseUrl,
                employeeIdMaxLength: item?.employeeIdMaxLength,
                chanelType: item?.channelType,
                showCreditApprovalDisclaimer: item?.showCreditApprovalDisclaimer,
                disclaimeralign: mappedDisclaimerAlignment,
                regions: Array.isArray(item?.regions) ? item.regions : [],
            };
        };

        const extractAemBrandPayload = (rawData) => {
            // Current AEM GraphQL shape: data.qrPortalDetailsList.items[]
            const items = rawData?.data?.qrPortalDetailsList?.items;
            if (Array.isArray(items) && items.length > 0) {
                // Only accept AEM data when the brand/clientName actually matches.
                const matchedItem = items.find((item) => {
                    const clientNames = Array.isArray(item?.clientName)
                        ? item.clientName
                        : [item?.clientName];
                    return clientNames.some((name) => brandMatches(name));
                });

                if (!matchedItem) {
                    return null;
                }

                return mapAemItemToBrandPayload(matchedItem);
            }

            // Backward-compatible fallback for any older payload shape.
            return extractLocalBrandPayload(rawData);
        };

        const applySelectedBrand = (selectedBrand, source) => {
            console.log(`Selected Brand Data Source: ${source}`);
            console.log('Selected Brand Data:', selectedBrand);
            setBrandData(selectedBrand);
            setBrandLogo(selectedBrand.brandlogo || defaultLogo);
            setRegionList(selectedBrand.regions || []);
        };

        const fetchBrandMapping = async () => {
            try {
                const response = await fetch(aemMappingUrl);
                if (!response.ok) {
                    return {};
                }

                const data = await response.json();
                return data?.brandMap && typeof data.brandMap === 'object' ? data.brandMap : {};
            } catch (error) {
                console.warn('Unable to load AEM brand mapping file. Using requested brand.', error);
                return {};
            }
        };

        const fetchSelectedBrand = async (sourceUrl, sourceType) => {
            const response = await fetch(sourceUrl);
            if (!response.ok) {
                throw new Error(`Config fetch failed: ${response.status}`);
            }

            const data = await response.json();
            if (Array.isArray(data?.errors) && data.errors.length > 0) {
                throw new Error('AEM query returned GraphQL errors');
            }

            if (sourceType === 'aem') {
                return extractAemBrandPayload(data);
            }

            return extractLocalBrandPayload(data);
        };

        const loadConfig = async () => {
            // Resolve requested brand through mapping file before querying AEM.
            const brandMap = await fetchBrandMapping();
            canonicalBrand = (brandMap[requestedBrand] || requestedBrand).toLowerCase();
            const brandPath = `/content/dam/aemacquisition/frictionless/en_us/${encodeURIComponent(canonicalBrand)}/`;
            const aemConfigUrl = `${aemGraphqlBaseUrl}/QRPortal;brandPath=${brandPath}`;

            console.log('Brand:', requestedBrand, 'Mapped brand for AEM:', canonicalBrand);

            try {
                // First preference: AEM data for mapped/requested brand.
                const aemSelectedBrand = await fetchSelectedBrand(aemConfigUrl, 'aem');
                if (aemSelectedBrand) {
                    applySelectedBrand(aemSelectedBrand, 'AEM');
                    return;
                }
                console.warn('Brand not found in AEM response, trying local config fallback.');
            } catch (error) {
                console.error(`Error loading config from ${aemConfigUrl}:`, error);
            }

            try {
                // Fallback: local config when AEM is empty/unavailable/non-matching.
                const localSelectedBrand = await fetchSelectedBrand(localConfigUrl, 'local');
                if (localSelectedBrand) {
                    applySelectedBrand(localSelectedBrand, 'Local config fallback');
                    return;
                }
                console.warn('Brand not found in local config fallback. Using default brand.');
            } catch (error) {
                console.error(`Error loading config from ${localConfigUrl}:`, error);
            }

            // Last resort default to keep page functional.
            setBrandData(defaultBrandData);
            setBrandLogo(defaultLogo);
            setRegionList([]);
        };

        loadConfig();
    }, []);

    // Update the URL with the embedded employee ID
    // useEffect(() => {
    //     if (brandData && employeeId) {
    //         // Start with the base URL
    //         let updatedURL = baseURL;
    
    //         // Replace clientName in the URL with the selected brand name
    //         if (brandData.brandname) {
    //             updatedURL = updatedURL.replace(/clientName=[^&]*/, `clientName=${brandData.brandname}`);
    //         }
    
    //         // Replace associateId in the URL with the entered employeeId
    //         if (employeeId) {
    //             updatedURL = updatedURL.replace(/associateId=[^&]*/, `associateId=${employeeId}`);
    //         }
            
    //         // Log the generated URL for debugging
    //         console.log('Generated QR Code URL:', updatedURL);
    
    //         // Set the full URL to be used in the QR code
    //         setFullURL(updatedURL);
    //     }
    // }, [brandData, employeeId]);
    useEffect(() => {
        if (brandData && employeeId) {
            let updatedURL = brandData?.configbaseurl || baseURL;
            
            // Special handling for 'advantage' brand
            if (brandData.brandname && brandData.brandname.toLowerCase() === 'advantage') {
                // Replace '&employeeApplication=true&inStore=true' with '&departmentId=STORE'
                updatedURL = updatedURL.replace('&employeeApplication=true&inStore=true', '&departmentId=STORE');
            }

            updatedURL = updatedURL.replace(/clientName=[^&]*/, `clientName=${brandData.brandname}`);
            const env = (brandData?.environment || 'prod').toLowerCase();
            // Replace only the host; default is prod host already in baseURL
            if (env === 'uat') {
                updatedURL = updatedURL.replace('acquire1.comenity.net', 'acquire1uat.comenity.net');
            } 
            updatedURL = updatedURL.replace(/associateId=[^&]*/, `associateId=${employeeId}`);
            
            // Apply URL parameters based on delivery method
            if (deliveryMethod === 'sms') {
                updatedURL += '&Channel=T&Subchannel=X';
            } else if (deliveryMethod === 'email') {
                updatedURL += '&Channel=4&Subchannel=B';
            } else if (deliveryMethod === 'QR Code') { // Default option
                // updatedURL += '&Channel=Q&Subchannel=3';
                updatedURL += `&Channel=${brandData?.chanelType || "Q"}&Subchannel=3`;
            }
    
            // Append cardChoiceCode based on selected product choice
            if (productChoice === 'traveladvantage') {
                updatedURL += '&cardChoiceCode=2';
            } else if (productChoice === 'dailyadvantage') {
                updatedURL += '&cardChoiceCode=1';
            }
    
            // Append clientVariable4 and overrideKey based on selected region
            if (region) {
                updatedURL += `&clientVariable4=${region}&overrideKey=${region}`;
            }
    
            // Append storeNumber if provided
            if (storeNumber) {
                updatedURL += `&storeNumber=${storeNumber}`;
            }
    
            setFullURL(updatedURL);  // Update the full URL
        }
    }, [brandData, employeeId, deliveryMethod, productChoice, region, storeNumber]);
    
    

       // Handle form submission for sending the link
   // Handle form submission for sending the link
        const handleSend = async () => {
            const recipient = deliveryMethod === 'email' ? email : phone; // Define recipient at the top
            const subject = "Quick Access to Your Application";
            const message = "Hello, here’s your secure link to complete the application.Please keep it handy for future reference.";
            
            alert(`Link sent via ${deliveryMethod === 'email' ? 'Email' : 'SMS'} to ${recipient}`);
            console.log("handleSend function triggered");
            console.log("Recipient:", recipient);
            console.log("Delivery Method:", deliveryMethod);

            const qrCodeBase64 = document.getElementById('qrCodeCanvas').toDataURL('image/png').split(',')[1];

            try {
                const response = await fetch('https://inclabsmsemail.azurewebsites.net/api/sendMessage', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        recipient,
                        deliveryMethod,
                        subject,
                        message,
                        link: fullURL,
                        qrCodeBase64,
                    }),
                });

                if (response.ok) {
                    console.log(`Message sent successfully via ${deliveryMethod}`);
                } else {
                    console.error(`Failed to send message via ${deliveryMethod}`);
                }
            } catch (error) {
                console.error('Error sending message:', error);
            }
        };

    return (
        <Container
            maxWidth="sm"
            className="container"
        >

            {/* Section to be printed */}
            <div className="print-section">
                <img 
                    src={brandLogo} 
                    alt="Brand Logo"
                />
                {/* <Typography variant="h4" gutterBottom>
                  Scan the QR Code to Apply for a {brandData?.brandcardname}
//followed copy below in qr-code-box
                  }
                    {employeeId &&
             </Typography> */}
             <Typography variant="h4" gutterBottom>
                  {resolvedMessage}
             </Typography>
                <Box className="qr-code-box">
                    {(
                        !brandData?.employeeIdMaxLength
                            ? employeeId
                            : employeeId.length > 0 && employeeId.length <= brandData.employeeIdMaxLength
                    ) && (
                                <>

                        <QRCode 
                            id="qrCodeCanvas"  // Adding an ID for easy selection
                            value={fullURL} 
                            size={200} // Increase QR code size
                        />
                        {/* <Typography variant="body2" align="center" style={{ marginTop: '8px' }}>
                                Credit card offers are subject to credit approval.<br></br><br></br>
                                AAA Travel Advantage Visa Signature® Credit Card or AAA Daily Advantage Visa Signature® Credit Card Accounts are issued by Comenity Capital Bank pursuant to a license from Visa U.S.A. Inc. Visa is a registered trademark of Visa International Service Association and used under license.
                        </Typography> */}
                        {brandData?.showCreditApprovalDisclaimer !== false && (
                        <Typography variant="body2" style={{ marginTop: '1rem' }}>
                                Credit card offers are subject to credit approval.<br></br><br></br>
                        </Typography>)}
                        {brandData?.disclaimer && (
                            <Box style={{ marginTop: brandData?.showCreditApprovalDisclaimer !== false ? undefined : '1.5rem',textAlign: brandData?.disclaimeralign || 'center' }}>
                                <Typography variant="body2" component="div" style={{ whiteSpace: 'pre-line' }}>
                                    {brandData.disclaimer}
                                </Typography>
                            </Box>
                        )}
                 
                        {/* Display Generated URL */}
            {showLinkDetail && fullURL && (
                <Typography 
                    variant="body2" 
                    className="breakable-url"
                    style={{ 
                        marginTop: '15px',
                        padding: '10px',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '5px',
                        textAlign: 'center',
                        maxWidth: '100%', 
                        wordBreak: 'break-word', // Ensures long words (URLs) wrap properly
                        overflowWrap: 'break-word', // Extra fallback for wrapping
                        overflowX: 'auto', // Allows scrolling for very long URLs
                        whiteSpace: 'normal', // Keeps text readable in blocks
                        fontSize: '14px',
                        color: '#333'
                    }}
                >
                    <strong>Generated URL:</strong> <a href={fullURL} target="_blank" rel="noopener noreferrer">{fullURL}</a>
                </Typography>
            )}
        </>
                        
                    )}
                </Box>
            </div>
    
            {/* Section visible only on screen, not for printing */}
            <div className="screen-section">
                {/* <Typography variant="h4" gutterBottom>
                        Scan the QR Code to Apply<sup>1</sup> for a AAA Visa Signature® credit card
                </Typography> */}
                 {/* Region and Club Dropdowns on the same line */}

            <Box display="flex" justifyContent="space-between" alignItems="center" style={{ marginBottom: '15px' }}>
            {showRegion && Array.isArray(regionList) && regionList.length > 0 && (
                <Select
                    value={region}
                    onChange={(e) => setRegion(e.target.value)}
                    displayEmpty
                    fullWidth
                    style={{ marginRight: '10px' }}
                >
                <MenuItem value="" disabled>
                    {brandData?.regionLabel || "Select Region"}
                </MenuItem>
                {Array.isArray(regionList) && regionList.length > 0 ? (
                regionList.map((region) => (
                    <MenuItem key={region.code} value={region.code}>
                    {region.label}
                    </MenuItem>
                ))
                ) : (
                <MenuItem value="" disabled>
                    No Regions Found
                </MenuItem>
                )}
                </Select>
                )}

            <TextField
                // label="Enter Branch Number"
                label = {brandData?.branchNumberLabel || "Enter Branch Number"}
                type="number"
                value={storeNumber}
                onChange={(e) => {
                    if(!brandData?.branchNumberMaxLength){setStoreNumber(e.target.value)}
                    else if(e.target.value.length <= brandData.branchNumberMaxLength) {setStoreNumber(e.target.value)}}
                }
                fullWidth
                className="store-number-input"  // Add this
                disabled={!!initialStore} // Disable if pre-filled from URL

            />
            </Box>

            {/* Product Choice Radio Buttons */}
          {/*   <Box display="flex" alignItems="center" style={{ marginBottom: '20px' }}>
                <Typography variant="subtitle1" style={{ marginRight: '10px' }}>Product Choice:</Typography>
                <RadioGroup
                    row
                    value={productChoice}
                    onChange={(e) => setProductChoice(e.target.value)}
                    defaultValue="dailyadvantage"
                >
                    <FormControlLabel value="dailyadvantage" control={<Radio />} label={brandData?.brandcardname || "BreadCashback Credit Card"}/> */}

                    {/* <FormControlLabel  value="dailyadvantage" control={<Radio />} label="Ford Pass Rewards Credit Card" /> */}

                    {/* <FormControlLabel value="dailyadvantage" control={<Radio />} label="Daily Advantage" /> */}
                    {/* <FormControlLabel value="traveladvantage" control={<Radio />} label="AAA Travel Advantage Visa Signature® Credit Card" />
                </RadioGroup>
            </Box> */}
            {/* Employee ID Input */}    
                <TextField
                    // label="Employee ID"
                    label = {brandData?.empidLabel || "Enter Employee ID"}
                    variant="outlined"
                    value={employeeId}
                    // inputProps={{maxLength: brandData?.employeeIdMaxLength || undefined}}
                    inputProps={{}}
                    helperText={brandData?.employeeIdMaxLength ? `Employee ID can be up to ${brandData.employeeIdMaxLength} characters` : ''}
                    onChange={(e) => 
                        {
                            const v= e.target.value;
                            const len = brandData.employeeIdMaxLength || 50;
                            if(len && v.length > len)  return;
                            // setEmployeeId(e.target.value)}
                             setEmployeeId(v)}

                        }
                    disabled={!!initialAssociateId} // Disable if pre-filled from URL
                />




                {/* DELIVERY METHOD SECTION */}
                {/* <FormControl 
                    component="fieldset"
                    style={{
                        marginTop: '20px',
                        width: '35rem',    // Fixed width for the form
                        textAlign: 'left', // Left-align content within the form
                        margin: '0 auto'   // Center the form control on the page
                    }}
                >       
                   <FormLabel component="legend" className="form-label">How would you like to receive the link?</FormLabel>

                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={1}>
                            <FormControlLabel
                                value="email"
                                control={<Radio />}
                                label=""
                                checked={deliveryMethod === 'email'}
                                onChange={() => setDeliveryMethod('email')}
                            />
                        </Grid>
                        <Grid item xs={11}>
                            <TextField
                                label="Enter your email"
                                variant="outlined"
                                fullWidth
                                disabled={deliveryMethod !== 'email'}
                                type="email" // Enforces email validation with standard HTML5 rules
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required={deliveryMethod === 'email'} // Make it mandatory if email option is selected
                                inputProps={{
                                    pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$", // Simple regex for basic email validation
                                }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} alignItems="center" style={{ marginTop: '10px' }}>
                        <Grid item xs={1}>
                            <FormControlLabel
                                value="sms"
                                control={<Radio />}
                                label=""
                                checked={deliveryMethod === 'sms'}
                                onChange={() => setDeliveryMethod('sms')}
                            />
                        </Grid>
                        <Grid item xs={11} style={{ marginTop: '10px' }}>
                            <TextField
                                label="Enter your phone number"
                                variant="outlined"
                                fullWidth
                                disabled={deliveryMethod !== 'sms'}
                                type="tel" // Set type as tel for phone numbers
                                value={phone}
                                onChange={(e) => setPhone(e.target.value.replace(/\D/, ""))} // Strip non-numeric input on change
                                inputProps={{
                                    inputMode: "numeric", // Provides numeric keyboard on mobile
                                    maxLength: 10, // Restrict input length to 10 digits
                                    pattern: "\\d{10}", // Regex pattern for exactly 10 digits
                                }}
                                required={deliveryMethod === 'sms'} // Make it mandatory if SMS option is selected
                            />
                        </Grid>
                    </Grid>
                    {employeeId && (
                        <Typography variant="body1" className="breakable-url" style={{ marginBottom: '15px', wordWrap: 'break-word' }}>
                             Link : <a href={fullURL} target="_blank" rel="noopener noreferrer">{fullURL}</a>
                        </Typography>
                    )}                    
                </FormControl> */}

                <Grid container spacing={2} justifyContent="center" style={{ marginTop: '20px' }}>
                    {/* <Grid item>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleSend}
                            disabled={!email && !phone}
                        >
                            {deliveryMethod === 'email' ? 'Send Email' : 'Send SMS'}
                        </Button>
                    </Grid> */}
                    <Grid item>
                        {/* <Button 
                            className="print-button"
                            variant="contained" 
                            color="secondary" 
                            onClick={() => window.print()}
                        > */}
                        <Button 
                            className="print-button"
                            variant="contained" 
                            onClick={() => window.print()}
                            style={{
                                backgroundColor: brandData?.brandcolor || '#003893',
                                color: 'white'
                            }}
                         >
                            Print QR Code
                        </Button>
                    </Grid>
                </Grid> 
            </div>
        </Container>
    );
    
}

export default QRCodeGenerator;
